/* eslint-disable prettier/prettier */
var storeArq = {
  data: {
    loaded: 0,
    idTokenNoVal: '',
    urlOrigen: '',
    tipo_integracion: '',
    auth: {
      userInfo: {
        nombre: '',
        apellidos: '',
        codired: '',
        identificador: '',
        email: '',
        division: '',
        subdivision: '',
        accionesWeb: [],
        rol: '',
        rolReal: ''
      },
      code_auth: '',
      access_token: '',
      refresh_token: '',
      logoutSys: false,
      exp: '',
      iat: '',
      current: 0,
      token: '',
      oid: '',
      propertiesAcWeb: []
    }
  },
  save: function save() {
    sessionStorage.setItem('storeArq.data', JSON.stringify(storeArq.data));
  },
  "delete": function _delete() {
    sessionStorage.removeItem('storeArq.data');
  },
  load: function load() {
    if (!storeArq.data.loaded) {
      var data = sessionStorage.getItem('storeArq.data');

      if (data) {
        storeArq.data = JSON.parse(data);
        storeArq.data.loaded = 1;
      }
    }
  }
};
export default storeArq;